"use strict";

// モバイル判定
import isMobile from "./modules/isMobile";
import addClassWithScroll from "./modules/addClassWithScroll";
// const resizeWidth = () => {
//   if (isMobile() === false) {
//   }
// };
const pageTop = () => {
  $("#pageTop").on("click", () => {
    $("body,html").animate(
      {
        scrollTop: 0
      },
      500
    );
    return false;
  });
};

const searchClick = () => {
  $("#search-btn").on("click", event => {
    $("#search-btn").toggleClass("on");
    $("#search-btn-close").toggleClass("on");
    $("#header-search").toggleClass("on");
  });
};

const toggleMenu = () => {
  $("#toggle-menu").on("click", () => {
    // if (isMobile()) {
    $("#toggle-menu").toggleClass("active");
    $(".header-menu__btn").toggleClass("active");
    $("#header-search").toggleClass("on");
    // var scrollTop = 0;
    if ($("#toggle-menu").hasClass("active")) {
      $("#sp-menu").css("display", "block");
      //position: fixed;でbodyのスクロールを禁止。スクロール位置もそのままで固定
      //メニューバーを開いた瞬間のスクロール位置を変数に保存
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      sessionStorage.setItem("scrollTopMenu", scrollTop);
      // $(".l-header").css({
      //   "margin-top": "0"
      // });
      $("body").css({
        position: "fixed"
      });
      $(".sp-nav__list").scrollTop(0);
      // console.log(scrollTop);
    } else {
      //メニューバーを開いた瞬間のスクロール位置を変数に保存
      $("#sp-menu").css("display", "none");
      // setTimeout(function() {
      // $(".l-header").css({
      //   "margin-top": "-50px"
      // });

      $("body").css({
        position: "static"
      });
      $("body, html").scrollTop(sessionStorage.getItem("scrollTopMenu"));

      // console.log(sessionStorage.getItem('scrollTopMenu'));
      // }, 200);
    }
    // }
  });
};

// イベント

{
  // console.log('即時実行');
  pageTop();
  searchClick();

  if (isMobile()) {
    // sp
    toggleMenu();
  } else {
    //  pc
  }
}

document.addEventListener(
  "DOMContentLoaded",
  () => {
    // console.log('DOM読み込み完了');
  },
  false
);

window.onload = () => {
  // console.log('ページ読み込み完了');
};

$(window).on("scroll", () => {
  addClassWithScroll(".fadein", "on");
});

// 現在の表示されているポスト数
var now_post_num = 5;
// 取得するポスト数
var get_post_num = 5;
$(function() {
  $("#more_disp").on("click", function() {
    $.ajax({
      type: "POST",
      url: ajaxurl,
      data: {
        action: "ajax_seemore",
        now_post_num: now_post_num,
        get_post_num: get_post_num
      },
      success: function(response) {
        // インクリメンタル
        now_post_num += get_post_num;
        response = JSON.parse(response);
        // htmlを挿入
        $(".js-hook-article")
          .filter(":last")
          .after(response.html);
        // 表示するデータがない場合にmoreボタンを非表示にする
        if (response.noDataFlg === 1) {
          $("#more_disp").hide();
        }
      },
      error: function(e) {}
    });
    return false;
  });
});
